import { useNavigate } from "react-router-dom";

const TermsAndConditions = () => {
  const navigate = useNavigate();
  return (
    <main className="dashboardLayoutSubSection rounded-xl">
      <section className="max-w-4xl mx-auto px-6 py-10">
        <button
          onClick={() => navigate(-1)}
          className="bg-myButtonBg hover:bg-myLabelText cursor-pointer text-white px-6 py-2 rounded-md"
        >
          Back
        </button>
        <h1 className="text-3xl font-bold text-gray-800 mb-2 text-center">
          Terms & Conditions
        </h1>
        <p className="text-sm text-gray-500 text-center mb-6">
          Last Updated: 27th September, 2025
        </p>

        <p className="text-gray-600 mb-6">
          Welcome to LLB360, a product of Saadruso Internet Media Pvt Ltd.
          (“Company,” “we,” “our,” or “us”). These Terms & Conditions (“Terms”)
          govern your access to and use of the LLB360 platform, including our
          website, mobile application, digital courses, legal resources, and
          related services (“Services”). By using LLB360, you agree to comply
          with these Terms. If you do not agree, you must discontinue use
          immediately.
        </p>

        <ol className="list-decimal list-inside space-y-4 text-gray-700">
          <li>
            <span className="font-semibold text-gray-800">Eligibility</span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                The Services are intended for law students, legal aspirants, and
                professionals preparing for exams or enhancing their knowledge.
              </li>
              <li>
                You must be at least 18 years of age or have parental/guardian
                consent if younger.
              </li>
              <li>
                By registering, you confirm that you are legally capable of
                entering into this agreement.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">User Accounts</span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                To access courses, notes, and assessments, you must create an
                account.
              </li>
              <li>
                You agree to provide accurate and updated information during
                registration.
              </li>
              <li>
                You are responsible for safeguarding your login credentials and
                any activity under your account.
              </li>
              <li>
                Unauthorized use of your account must be reported immediately.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Subscriptions & Payments
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                Access to premium content, practice tests, and advanced features
                requires a paid subscription.
              </li>
              <li>
                Subscription plans are displayed at the time of purchase
                (Yearly, Semester, or Subject-wise).
              </li>
              <li>
                Payments are non-refundable except as permitted under our Refund
                Policy.
              </li>
              <li>
                Auto-renewal applies unless canceled before the renewal date.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">Use of Services</span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                Use the platform strictly for personal educational purposes.
              </li>
              <li>
                Do not share, resell, or distribute our study material, PDFs,
                videos, or test data without authorization.
              </li>
              <li>
                Do not engage in any activity that disrupts the functioning of
                the platform.
              </li>
              <li>
                Do not use the platform for cheating, malpractice, or unfair
                exam assistance.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Intellectual Property Rights
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                All study notes, case summaries, mock tests, videos, and digital
                content provided by LLB360 are our intellectual property.
              </li>
              <li>
                You are granted a limited, non-transferable, non-exclusive
                license for personal use.
              </li>
              <li>
                Reproduction, resale, recording, or distribution of content
                without permission is strictly prohibited and may result in
                legal action.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              User-Generated Content
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                If you contribute material (e.g., comments, feedback, peer
                discussion inputs), you retain ownership but grant us a
                royalty-free, worldwide license to use such content for
                educational and community purposes.
              </li>
              <li>
                You agree not to post unlawful, defamatory, or harmful material.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Limitation of Liability
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                LLB360 provides educational support, but does not guarantee exam
                success, ranks, or job opportunities.
              </li>
              <li>
                We are not liable for indirect or incidental damages arising
                from the use of the Services.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Disclaimer of Warranties
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                The Services are provided “as is” without warranties, express or
                implied.
              </li>
              <li>
                We do not warrant uninterrupted availability or that content
                will always be error-free.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">
              Suspension & Termination
            </span>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>
                We reserve the right to suspend or terminate your account if you
                violate these Terms.
              </li>
              <li>
                Termination may result in loss of access to your subscribed
                content.
              </li>
            </ul>
          </li>

          <li>
            <span className="font-semibold text-gray-800">Governing Law</span>
            <p className="mt-2 text-gray-600">
              These Terms shall be governed by and construed in accordance with
              the laws of India, with exclusive jurisdiction of the courts in
              Hyderabad, Telangana.
            </p>
          </li>

          <li>
            <span className="font-semibold text-gray-800">Modifications</span>
            <p className="mt-2 text-gray-600">
              We may revise these Terms at any time. Updates will be posted on
              this page, and your continued use of the Services will signify
              acceptance.
            </p>
          </li>

          <li>
            <span className="font-semibold text-gray-800">Contact Us</span>
            <p className="mt-2 text-gray-600">
              For any questions or concerns, please contact:
            </p>
            <ul className="list-disc list-inside pl-6 mt-2 space-y-2 text-gray-600">
              <li>Saadruso Internet Media Pvt Ltd.</li>
              <li>Email: contact@llb360.com</li>
              <li>Phone: 7673937360</li>
              <li>
                Address: Plot # 28, Doyens Township, Serilingampally, Hyderabad
                – 500 019
              </li>
            </ul>
          </li>
        </ol>
      </section>
    </main>
  );
};

export default TermsAndConditions;
